import { render, staticRenderFns } from "./AttachTargetToParam.vue?vue&type=template&id=50fa5684"
import script from "./AttachTargetToParam.vue?vue&type=script&lang=js"
export * from "./AttachTargetToParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports